import { io } from 'socket.io-client';

const SIZE = 9;

class PlayEngine {
  level = null;
  socket = null;

  constructor({ level, hostUrl, onMove, onBegin, onEndGame, onUndo }) {
    this.level = level;
    this.hostUrl = hostUrl;
    this.onMove = onMove;
    this.onBegin = onBegin;
    this.onEndGame = onEndGame;
    this.onUndo = onUndo;
  }

  handleHumanPlay({ vertex, color }) {
    if (!this.socket) return;
    this.socket.emit('play', { vertex, color });
  }

  genMove({ color }) {
    if (!this.socket) return;
    this.socket.emit('genPlay', { color });
  }

  joinRoom(roomId) {
    this.mode = 'ai';
    const aiLevel = this.level;
    console.debug('Connecting to', this.hostUrl);
    this.socket = io(this.hostUrl, {
      transports: ["websocket", "polling"],
      path: "/socket.io/",
    });

    this.socket.on('connect', () => {
      this.socket.emit('joinRoom', { roomId, aiLevel });
      console.info(
        `เข้าห้อง ${roomId} แล้ว (โหมด: ${this.mode}${
          this.mode === 'ai' ? `, AI=${aiLevel}` : ''
        })`
      );
    });

    this.socket.on(
      'beginGame',
      ({
        blackLegals,
        whiteLegals,
        blackStones,
        whiteStones,
        blackCapture,
        whiteCapture,
      }) => {
        console.debug('Socket beginGame received:', {
          blackCapture,
          whiteCapture,
          blackStones,
          whiteStones,
          blackLegals,
          whiteLegals,
        });
        this.onBegin({
          blackLegals,
          whiteLegals,
          blackStones,
          whiteStones,
          blackCapture,
          whiteCapture,
        });
      }
    );

    this.socket.on('roomInfo', (info) => {});

    this.socket.on(
      'move',
      ({
        color,
        vertex,
        blackCapture,
        whiteCapture,
        blackStones,
        whiteStones,
        blackLegals,
        whiteLegals,
      }) => {
        console.debug('Socket move received:', {
          color,
          vertex,
          blackCapture,
          whiteCapture,
          blackStones,
          whiteStones,
          blackLegals,
          whiteLegals,
        });

        this.onMove({
          color,
          vertex,
          blackCapture,
          whiteCapture,
          blackStones,
          whiteStones,
          blackLegals,
          whiteLegals,
        });
      }
    );

    this.socket.on(
      'undo',
      ({
        color,
        vertex,
        blackCapture,
        whiteCapture,
        blackStones,
        whiteStones,
        blackLegals,
        whiteLegals,
      }) => {
        console.debug('Socket move received:', {
          color,
          vertex,
          blackCapture,
          whiteCapture,
          blackStones,
          whiteStones,
          blackLegals,
          whiteLegals,
        });

        this.onUndo({
          color,
          vertex,
          blackCapture,
          whiteCapture,
          blackStones,
          whiteStones,
          blackLegals,
          whiteLegals,
        });
      }
    );

    this.socket.on('turn', ({ turn: t }) => {
      this.turn = t;
    });

    // socket.on('resetBoard', resetBoard);
    this.socket.on('errorMsg', (m) => alert(m));
    this.socket.on('status', (s) => {
      console.info(s.msg);
    });

    this.socket.on(
      'gameEnded',
      ({
        result: score,
        deadList: dead,
        blackTerritory,
        whiteTerritory,
        blackCapture,
        whiteCapture,
      }) => {
        // result like "B+5.5"
        this.onEndGame({
          score,
          dead,
          blackTerritory,
          whiteTerritory,
          blackCapture,
          whiteCapture,
        });
        //   if (deadList) {
        //     // deadList may be points like "D4 C3 ..." - mark them
        //     const pts = deadList.split(/\s+/).filter(Boolean);
        //     pts.forEach((p) => {
        //       const parsed = this.parseGtpCoord(p);
        //       if (parsed) {
        //         const st = this.getStone(parsed.x, parsed.y);
        //         if (st) st.dead = true;
        //       }
        //     });
        //     // drawBoard();
        //   }
      }
    );

    this.socket.on('showboard', (msg) => {
      console.debug('showboard', msg);
    });
  }

  endGame() {
    if (this.socket) {
      this.socket.emit('endGame');
    }
  }

  static xyToVertex(row, col) {
    const letters = 'ABCDEFGHJKLMNOPQRST';
    const colLetter = letters[col];
    const rowNumber = row + 1;
    return `${colLetter}${rowNumber}`;
  }

  parseGtpCoord(gtp) {
    if (!gtp) return null;
    const letters = 'ABCDEFGHJKLMNOPQRST'.slice(0, SIZE);
    const colLetter = gtp[0];
    const row = parseInt(gtp.slice(1), 10);
    const x = letters.indexOf(colLetter);
    const y = SIZE - row;
    if (x < 0 || isNaN(y)) return null;
    return { x, y };
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  showboard() {
    if (!this.socket) return;
    this.socket.emit('showboard');
  }

  undo() {
    if (!this.socket) return;
    this.socket.emit('undo');
  }
}

export { PlayEngine };
